import React from 'react'
import ThemeChose from '@components/LocalMerchant/ThemeChose'
import ProductIntro from '@common/ProductIntro'
import { PRODUCT_THEME_TEMPLATE } from '@constant'

export default {
  path: 'themeChose',
  indexRoute: {
    component: ThemeChose
  },
  childRoutes: [
    {
      path: 'intro',
      components: props => (
        <ProductIntro {...props} id={PRODUCT_THEME_TEMPLATE} />
      )
    }
  ]
}
